var CID = 'c_c21utqjf';
var ACTION_TYPE = {
  showEvt: 'view',
  clickEvt: 'click'
};
export var showGroupByLog = function showGroupByLog(performance_id) {
  window.seedAction({
    evt: ACTION_TYPE.showEvt,
    bid: 'b_movie_ztrcbf6r_mv',
    cid: CID,
    custom: {
      performance_id: performance_id
    }
  });
};
export var showBuyNowLog = function showBuyNowLog(performance_id, groupbuying_id) {
  window.seedAction({
    evt: ACTION_TYPE.showEvt,
    bid: 'b_movie_ip0qmmzc_mv',
    cid: CID,
    custom: {
      performance_id: performance_id,
      groupbuying_id: groupbuying_id
    }
  });
};
export var showNotBuyLog = function showNotBuyLog(performance_id, groupbuying_id) {
  window.seedAction({
    evt: ACTION_TYPE.showEvt,
    bid: 'b_movie_xgsgiwnt_mv',
    cid: CID,
    custom: {
      performance_id: performance_id,
      groupbuying_id: groupbuying_id
    }
  });
};
export var clickNotBuyLog = function clickNotBuyLog(performance_id, groupbuying_id) {
  window.seedAction({
    evt: ACTION_TYPE.clickEvt,
    bid: 'b_movie_xgsgiwnt_mc',
    cid: CID,
    custom: {
      performance_id: performance_id,
      groupbuying_id: groupbuying_id
    }
  });
};
export var clickBuyNowLog = function clickBuyNowLog(performance_id, groupbuying_id) {
  window.seedAction({
    evt: ACTION_TYPE.clickEvt,
    bid: 'b_movie_ip0qmmzc_mc',
    cid: CID,
    custom: {
      performance_id: performance_id,
      groupbuying_id: groupbuying_id
    }
  });
};
export var showSeeAllLog = function showSeeAllLog(performance_id) {
  window.seedAction({
    evt: ACTION_TYPE.showEvt,
    bid: 'b_movie_yau8a1ro_mv',
    cid: CID,
    custom: {
      performance_id: performance_id
    }
  });
};
export var clickShowAllLog = function clickShowAllLog(performance_id) {
  window.seedAction({
    evt: ACTION_TYPE.clickEvt,
    bid: 'b_movie_yau8a1ro_mc',
    cid: CID,
    custom: {
      performance_id: performance_id
    }
  });
};
export var showPopupLog = function showPopupLog(performance_id) {
  window.seedAction({
    evt: ACTION_TYPE.showEvt,
    bid: 'b_movie_u1qm498q_mv',
    cid: CID,
    custom: {
      performance_id: performance_id
    }
  });
};